import api from '../services/api';

export interface ITenant {
  id: string;
  name: string;
  created_at?: string;
}

export const getTenants = async (): Promise<ITenant[]> => {
  const response = await api.get('/tenants');
  return response.data;
};

export const createTenant = async (name: string): Promise<ITenant> => {
  const response = await api.post('/tenants', { name });
  return response.data;
};

export const getTenantByName = async (name: string): Promise<ITenant> => {
  const response = await api.get(`/tenants/${name}`);
  return response.data;
};

export const isTenantNameAvailable = async (name: string): Promise<boolean> => {
  try {
    await getTenantByName(name);
    return false;
  } catch (err: any) {
    if (err.response?.status === 404) {
      return true;
    }
    throw err;
  }
};
